import { useEffect, useState } from "react";
import axios from "../Context/axiosInstance";

export default function AcademicLevelSelect({ value, onChange, disabled, ...props }) {
  const [levels, setLevels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    axios.get("/academic-levels").then(({ data }) => {
      if (active) setLevels(data);
    }).catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);
  return <>
    <select {...props} aria-label={props["aria-label"] || "Academic level"} value={value ?? ""} onChange={onChange} disabled={disabled || loading || error || !levels.length}>
      <option value="" disabled>{loading ? "Loading academic levels..." : error ? "Could not load academic levels" : !levels.length ? "No academic levels available" : "Select Academic Level"}</option>
      {levels.map((level) => <option key={level.id} value={level.id}>{level.name}</option>)}
    </select>
    {error && <p role="alert" className="mt-1 text-sm text-red-500">Could not load academic levels. <button type="button" onClick={() => setAttempt((current) => current + 1)} className="underline">Retry academic levels</button></p>}
  </>;
}
